import {
  SmileyIcon,
  SmileyMehIcon,
  SmileySadIcon,
  SmileyWinkIcon,
  SmileyXEyesIcon,
  TagIcon,
  UserIcon,
  NotebookIcon,
  CalendarBlankIcon,
} from '@phosphor-icons/react'

// Re-export icon types for consumers
export {
  UserIcon,
  NotebookIcon,
  TagIcon,
  SmileyIcon,
  SmileyMehIcon,
  CalendarBlankIcon,
} from '@phosphor-icons/react'

/**
 * Mood options with corresponding icons.
 * Can be used for journals, daily check-ins, etc.
 */
export const MOOD_OPTIONS = [
  { value: 1, label: 'very low', Icon: SmileyXEyesIcon },
  { value: 2, label: 'low', Icon: SmileySadIcon },
  { value: 3, label: 'neutral', Icon: SmileyMehIcon },
  { value: 4, label: 'good', Icon: SmileyIcon },
  { value: 5, label: 'great', Icon: SmileyWinkIcon },
] as const

/**
 * Get the mood option for a given value
 */
export function getMoodOption(value: number) {
  return MOOD_OPTIONS.find((m) => m.value === value)
}

/**
 * Property configuration icons - use these for consistent iconography
 */
export const PROPERTY_ICONS = {
  mood: SmileyMehIcon,
  people: UserIcon,
  project: NotebookIcon,
  dueDate: CalendarBlankIcon,
} as const
